<template>
  <div class="app-dashboard">
    <div class="dashboard-container">
      <div class="row row-cols-1 row-cols-md-3 dashboard-row">
        <div class="col dashboard-col">
          <stat-card
            :title="t('Revenue')"
            :value="
              formatCurrency(
                dashboardData.total_economy_summary &&
                  dashboardData.total_economy_summary.totalIncome
              ) || '-'
            "
            :empty-text="t('No income data')"
            icon="DollarSignIcon"
            color="success"
            :loading="loading"
            compact
          />
        </div>
        <div class="col dashboard-col">
          <stat-card
            :title="t('Cost')"
            :value="
              formatCurrency(
                dashboardData.total_economy_summary &&
                  dashboardData.total_economy_summary.totalBaseCost
              ) || '-'
            "
            :empty-text="t('No cost data')"
            icon="TrendingDownIcon"
            color="danger"
            :loading="loading"
            compact
          />
        </div>
        <div class="col dashboard-col">
          <stat-card
            :title="t('Profit')"
            :value="
              formatCurrency(
                dashboardData.total_economy_summary &&
                  dashboardData.total_economy_summary.totalProfit
              ) || '-'
            "
            :empty-text="t('No profit data')"
            icon="TrendingUpIcon"
            color="primary"
            :loading="loading"
            compact
          />
        </div>
      </div>

      <div class="row row-cols-1 row-cols-md-2 dashboard-row">
        <div class="col dashboard-col">
          <stat-card
            :title="t('Profitability')"
            :value="
              formatPercentage(
                dashboardData.total_economy_summary &&
                  dashboardData.total_economy_summary.totalProfitMargin
              ) || '-'
            "
            :empty-text="t('No profit margin data')"
            icon="PercentIcon"
            color="info"
            :loading="loading"
            compact
          />
        </div>
        <div class="col dashboard-col">
          <stat-card
            :title="t('Total Number of Accepted Shipments')"
            :value="
              formatNumber(
                dashboardData.total_economy_summary && dashboardData.total_economy_summary.count
              ) || '-'
            "
            :empty-text="t('No consignment data')"
            icon="PackageIcon"
            color="warning"
            :loading="loading"
            compact
          />
        </div>
      </div>

      <!-- <div class="row row-cols-1 dashboard-row">
        <div class="col dashboard-col">
          <chart-card
            :title="t('Popular Destinations Analysis')"
            :loading="loading"
            :is-empty="!hasDestinationAnalyseData"
            :empty-text="t('No destination analysis data available')"
          >
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>{{ t('Country') }}</th>
                    <th>{{ t('Consignment Count') }}</th>
                    <th>{{ t('Total Price') }}</th>
                    <th>{{ t('Total Profit') }}</th>
                  </tr>
                </thead>
                <tbody v-if="!loading && hasDestinationAnalyseData">
                  <tr v-for="(item, index) in getDestinationAnalyseItems" :key="index">
                    <td>{{ item.name }}</td>
                    <td>{{ item.consignmentCount }}</td>
                    <td>{{ item.totalPrice }}</td>
                    <td>{{ item.totalProfit }}</td>
                  </tr>
                </tbody>
                <tbody v-else-if="loading">
                  <tr>
                    <td colspan="4" class="text-center">{{ t('Loading...') }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="4" class="text-center">{{ t('No data available') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <line-chart
                :title="t('Popular Destinations Analysis')"
                :loading="loading"
                :is-empty="!hasDestinationAnalyseData"
                :empty-text="t('No destination analysis data available')"
              />
            </div>
          </chart-card>
        </div>
      </div> -->

      <!-- <div class="row row-cols-1 dashboard-row">
        <div class="col dashboard-col">
          <chart-card
            :title="t('Special Service Usage')"
            :loading="loading"
            :is-empty="!hasSpecialServiceData"
            :empty-text="t('No special service data available')"
          >
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>{{ t('Service Type') }}</th>
                    <th>{{ t('Total Fee') }}</th>
                    <th>{{ t('Usage Count') }}</th>
                    <th>{{ t('Percentage') }}</th>
                  </tr>
                </thead>
                <tbody v-if="!loading && hasSpecialServiceData">
                  <tr v-for="(item, index) in getSpecialServiceItems" :key="index">
                    <td>{{ item.serviceDescription }}</td>
                    <td>{{ item.totalFee || '-' }}</td>
                    <td>{{ item.usage || '-' }}</td>
                    <td>
                      {{
                        (
                          (item.usage / getSpecialServiceItems.reduce((a, b) => a + b.usage, 0)) *
                          100
                        ).toFixed(2)
                      }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </chart-card>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import useService from '@/auth/service/useService';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import { StatCard } from '../../components';

export default {
  components: {
    StatCard
  },
  mixins: [helper],
  props: {
    selectedFilter: {
      type: String,
      default: 'thisYear'
    },
    shipmentDirection: {
      type: [Number, String],
      default: null
    }
  },
  setup() {
    const { t } = useI18nUtils();
    return {
      t
    };
  },
  data() {
    return {
      loading: true,
      dashboardData: {}
    };
  },
  computed: {
    fetchKey() {
      return [this.selectedFilter, this.shipmentDirection].join('|');
    },
    hasDestinationAnalyseData() {
      return (
        this.dashboardData.popular_destination_analyse &&
        this.dashboardData.popular_destination_analyse.length > 0
      );
    },
    getDestinationAnalyseItems() {
      if (!this.hasDestinationAnalyseData) return [];

      return this.dashboardData.popular_destination_analyse.map(item => ({
        name: item.name,
        consignmentCount: this.formatNumber(item.consignmentCount),
        totalPrice: this.formatCurrency(item.totalPrice),
        totalProfit: this.formatCurrency(item.totalProfit)
      }));
    },

    hasSpecialServiceData() {
      return (
        this.dashboardData.special_service_usage &&
        this.dashboardData.special_service_usage.length > 0
      );
    },
    getSpecialServiceItems() {
      if (!this.hasSpecialServiceData) return [];

      return this.dashboardData.special_service_usage;
    }
  },
  methods: {
    async loadData() {
      this.loading = true;

      try {
        const args = { currentTab: 2, dateBetween: this.selectedFilter };
        if (this.shipmentDirection !== null && this.shipmentDirection !== undefined) {
          args.transportDirection = this.shipmentDirection;
        }
        const res = await useService.getDashboard(args);
        this.dashboardData = res.data;
      } catch (error) {
        this.dashboardData = {};
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    fetchKey: {
      immediate: true,
      handler() {
        if (this.shipmentDirection == null) return;
        this.loadData();
      }
    }
  }
};
</script>
